import { render, staticRenderFns } from "./PaylasimYorum.vue?vue&type=template&id=22e02a88&"
import script from "./PaylasimYorum.vue?vue&type=script&lang=js&"
export * from "./PaylasimYorum.vue?vue&type=script&lang=js&"
import style0 from "./PaylasimYorum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports